// extracted by mini-css-extract-plugin
module.exports = {"saveContactInfo__modal":"saveContactInfo__modal-2dFsx","root":"root-3qosI","saveContactInfo__title":"saveContactInfo__title-1BLzE"};